import { View } from 'components/View'
import React from 'react'

export default function Row (props) {
  return (
    <View row {...props} />
  )
}
